import { render, staticRenderFns } from "./DataTableTab.vue?vue&type=template&id=5bc709cd&scoped=true"
import script from "./DataTableTab.vue?vue&type=script&lang=js"
export * from "./DataTableTab.vue?vue&type=script&lang=js"
import style0 from "./DataTableTab.vue?vue&type=style&index=0&id=5bc709cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc709cd",
  null
  
)

export default component.exports